import { Injectable } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { customFormFields } from "../models/customFormFields";

@Injectable({
    providedIn : 'root'
})
export class UtilityService{
  lat: string = '';
  lng: string = '';

    constructor(private fb : FormBuilder) {}

    creatFormGroup(formFields :customFormFields[]) : FormGroup{
        const formGroupConfig: { [key: string]: any } = {};
          for (const field of formFields) {
            const validators = field.validators.map(validatorFn => validatorFn.bind(this));
            formGroupConfig[field.control] = ['', validators];
          }
         return this.fb.group(formGroupConfig);
       }

       updateFormControlValue(form : FormGroup, control : string, value: string){
        form.controls[control].setValue(value);
        form.controls[control].updateValueAndValidity();
      }


    setOrRemoveRequired(contactForm : FormGroup,name : string, isSet : boolean): void {
        const salControl = contactForm.get(name) as FormControl;
        if (salControl) {
          if(isSet){
            salControl.setValidators([Validators.required]);
            salControl.updateValueAndValidity();
          }else{
            salControl.setValidators(null);
            salControl.updateValueAndValidity();
          }
        }
      }


    customResetFormGroup(contactForm : FormGroup, arrayOfContact : any[]){
        arrayOfContact.forEach( val =>{
          const control = contactForm.get(val);
          if (control) {
            control.setValue('');
            control.setErrors(null);
            control.markAsPristine();
            control.markAsUntouched();
            control.updateValueAndValidity();
          }
        })
      }


      objectToQueryParams(value: any): string {
        const queryParams = [];
        for (const key in value) {
            if (value.hasOwnProperty(key)) {
                const encodedKey = encodeURIComponent(key);
                const encodedValue = encodeURIComponent(value[key]);
                queryParams.push(`${queryParams.length === 0 ? '?' : '&'}${encodedKey}=${encodedValue}`);
            }
        }
        return queryParams.join('');
    }
  
    public dateFormatter(date : string) : string{
      const pDate = new Date(date);
      const year = pDate.getFullYear();
      const month = String(pDate.getMonth() + 1).padStart(2, '0'); // Months are zero-based, so we add 1
      const day = String(pDate.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`; 
    }

  
}